import { useRouter } from '~/utils/navigation';
import useContextualPathTransformer from '~/hooks/use-contextual-path-transformer';

const usePushTransformedPath = () => {
	const transformPath = useContextualPathTransformer();
	const router = useRouter();

	const pushTransformedPath = (path: string, state?: Record<string, unknown>) => {
		// TODO (navigation) - use search params or redux for state
		router.push(transformPath(path, {}), { state });
	};

	return pushTransformedPath;
};

export default usePushTransformedPath;
